<template>
	<section class="container__body container__body--lg">

		<section class="wrap--xsm center">

			<i class="fas fa-thumbs-up icon--xlg margin-b-50"></i>

			<h1>Klar til at sælge?</h1>

			<h3>Godkend produktet og det vil herefter blive publiceret.</h3>

			<button class="btn btn--md btn--primary primary--copper margin-t-50" @click.prevent="activateProduct">

				<span>Godkend produkt</span>

			</button>

		</section>

	</section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "approve",
        computed: {
            ...mapGetters({
                product: 'product'
            }),
        },
		methods:{
            activateProduct(){
                axios.put(`/api/admin/product/${this.product.id}/activate`).then(response=>{
                    this.$router.replace({
                        name:'product.index',
                    });
				});
			},
            beforeRouteEnter(to, from, next){
                next(vm=>{
                    vm.$store.dispatch('getProduct', vm.$route.params.product);
                })
            },
		}
    }
</script>

<style scoped>

</style>
